<template>
  <div class="searchIpt clearFix">
    <div style="width: 200px;height: 20px;border: 1px">{{value}}</div>
    <!--<div class="clearFix">-->
      <!--<input type="text" :value="value" :placeholder="placeholder" @click="selectShow = !selectShow" readonly/>-->
    <!--</div>-->
    <ul style="list-style: none" @click="selectShow = !selectShow">
      <slot v-if="selectShow"/>
    </ul>
  </div>

</template>

<script>
    export default {
      data(){
        return {
          selectShow:false,
        }
      },
      props:{
        placeholder:String,
        value:{type:String},
      },
      watch:{
        value(data){
          console.log(data);
        }
      }


    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/select.vue